<template>
    <div class="login">
        <div class="loginDialog">
            <!--      <div class="loginDialog" :style="{height:ifLoginRoRegister=='Y'?'720px':'770px',background:ifLoginRoRegister=='Y'?'url('+loginURL+') 100% 100% no-repeat':'url('+registerURL+') 100% 100% no-repeat'}">-->
            <div class="loginForm">
                <!--        <img style="cursor:pointer;" class="closeClass" @click="closeLoginDialog()" src="@/assets/images/new_lo_close.png" />-->
                <div class="contentClass" :style="{height:ifLoginRoRegister=='Y'?'485px':'640px'}">
                    <img style="cursor:pointer;" class="closeClass" @click="closeLoginDialog()"
                         src="@/assets/images/new_lo_close.png"/>
                    <Row style="margin-top:30px" type="flex" justify="center" align="middle"
                         @keydown.enter.native="submitLogin">
                        <Col style="width: 400px;">
                            <Row>
                                <Tabs v-model="tabName" @on-click="changeTabs">
                                    <TabPane :label="$t('usernameLogin')" name="username">
                                        <Form  v-if="tabName=='username'" ref="usernameLoginForm" :model="form" :rules="rules" class="form" >
                                            <FormItem class="loginInput" prop="username">
                                                <div class="logincom">
                                                    <Input type="text" v-model="form.username" maxlength="11" placeholder="请输入手机号"  autocomplete="off"  @on-blur="checkRegister('userName')" @on-change="ver_disabled = 'none' "/>
                                                </div>
                                            </FormItem>
                                          <FormItem prop="imgCode">
                                            <Row
                                                type="flex"
                                                justify="space-between"
                                                style="align-items: center;overflow: hidden;"
                                            >
                                              <Input
                                                  v-model="form.imgCode"
                                                  clearable
                                                  placeholder="请输入图片验证码"
                                                  :maxlength="10"
                                                  class="input-verify"
                                                  style="width: 298px"
                                              />
                                              <div style="position:relative">
                                                <Spin v-if="loadingCaptcha" fix></Spin>
                                                <img
                                                    :src="captchaImg"
                                                    @click="getCaptchaImg"
                                                    alt="加载验证码失败"
                                                    style="width:100px;cursor:pointer;display:block;height:48px"
                                                />
                                              </div>
                                            </Row>
                                          </FormItem>
                                            <FormItem class="loginInput" prop="verifyCode">
                                                <div class="logincom">
                                                    <Input type="text" v-model="form.verifyCode" placeholder="请输入验证码"  autocomplete="off"/>
                                                    <div @click="_postLoginSendSmsCode('4')" class="loginVertial"
                                                         :style="{pointerEvents:ver_disabled}">{{(verifyCode_time >= 0
                                                        && verifyCode_time <= 60)? verifyCode_time + 's' :
                                                        verifyCode_time}}
                                                    </div>
                                                </div>
                                              <p style="line-height: 18px; font-size: 12px;">如遇验证码问题请联系客服</p>
                                            </FormItem>
                                        </Form>
                                    </TabPane>
                                    <TabPane :label="$t('mobileLogin')" name="mobile">
                                        <Form v-if="tabName=='mobile'" ref="mobileLoginForm" :model="form" :rules="rules"  class="form" >
                                            <FormItem v-if="ifLoginRoRegister=='Y'" class="loginInput" prop="username">
                                                <div class="logincom">
                                                    <Input v-model="form.username" placeholder="绑定邮箱、手机号码"  autocomplete="off" @on-blur="checkRegister('phoneEmail')" />
                                                </div>
                                            </FormItem>
                                            <FormItem v-if="ifLoginRoRegister=='Y'" class="loginInput" prop="passwordOld">
                                                <div class="logincom">
                                                    <Input type="password" v-model="form.passwordOld"  placeholder="请输入密码" autocomplete="off"/>
                                                </div>
                                            </FormItem>

                                            <FormItem v-if="ifLoginRoRegister=='N'" class="loginInput" style="height: 25px;">
                                                <div class="logincom">
                                                    <input type="radio" name="type"  :value="1"  v-model="registerType"  />
                                                    <span style="margin-left: 6px;">个人用户</span>
                                                    <input type="radio" name="tpye"  :value="2"  v-model="registerType" style="margin-left: 40px;" />
                                                    <span style="margin-left: 6px;">企业用户</span>
                                                </div>
                                            </FormItem>

                                            <FormItem v-if="ifLoginRoRegister=='N'" class="loginInput">
                                                <div class="logincom" v-if="registerType =='1'">
                                                    <Input  type="text" v-model="form.name" placeholder="请输入您的真实姓名"/>
                                                </div>
                                                <div class="logincom" v-if="registerType =='2'">
                                                    <Input  type="text" v-model="form.enterpriseName" placeholder="请输入企业名称"/>
                                                </div>
                                            </FormItem>
                                            <FormItem v-if="ifLoginRoRegister=='N'" class="loginInput">
                                                <div class="logincom" v-if="registerType =='1'">
                                                    <Select v-model="form.occupation" placeholder="请选择职业">
                                                        <Option value="服装设计师">服装设计师</Option>
                                                        <Option value="平面设计师">平面设计师</Option>
                                                        <Option value="广告设计师">广告设计师</Option>
                                                        <Option value="珠宝设计师">珠宝设计师</Option>
                                                        <Option value="品牌设计师">品牌设计师</Option>
                                                        <Option value="造型设计师">造型设计师</Option>
                                                    </Select>
                                                </div>
                                                <div class="logincom" v-if="registerType =='2'">
                                                    <Select v-model="formCategory" placeholder="请选择企业类别">
                                                        <Option value="独立设计师品牌公司">独立设计师品牌公司</Option>
                                                        <Option value="服装品牌公司">服装品牌公司</Option>
                                                        <Option value="服装加工企业">服装加工企业</Option>
                                                        <Option value="面料企业">面料企业</Option>
                                                        <Option value="产业集群园区">产业集群园区</Option>
                                                        <Option value="showroom">showroom</Option>
                                                        <Option value="商场/商城/购物中心">商场/商城/购物中心</Option>
                                                        <Option value="时尚协会">时尚协会</Option>
                                                        <Option value="中国商标协会会员">中国商标协会会员</Option>
                                                        <Option value="其他">其他</Option>
                                                    </Select>
                                                </div>
                                            </FormItem>

                                            <FormItem v-if="ifLoginRoRegister=='N'&&registerType =='2' && formCategory=='其他'" class="loginInput">
                                                <div class="logincom">
                                                    <Input  type="text" v-model="categoryOther" placeholder="请输入企业类别"/>
                                                </div>
                                            </FormItem>

                                            <FormItem v-if="ifLoginRoRegister=='N'" class="loginInput">
                                                <div class="logincom">
                                                    <div class="item_content" style="color: #CBCBCB;">
                                                        <Select class="item_city_list" v-model="countrySelection">
                                                            <Option :value="countrySelection">{{countrySelection}}
                                                            </Option>
                                                        </Select>
                                                        —
                                                        <Select class="item_city_list" v-model="provincesSelection"
                                                                @on-change="provinceChange">
                                                            <Option v-for="(item,index) in cityData" :value="index">
                                                                {{index}}
                                                            </Option>
                                                        </Select>
                                                        —
                                                        <Select class="item_city_list" v-model="citySelection">
                                                            <Option v-for="(item,index) in cityData[provincesSelection]"
                                                                    :value="item">{{item}}
                                                            </Option>
                                                        </Select>

                                                    </div>
                                                </div>
                                            </FormItem>
                                            <FormItem v-if="ifLoginRoRegister=='N'" class="loginInput" >
                                                <div class="logincom" v-if="registerType=='1'">
                                                    <Select v-model="form.gender" placeholder="请选择您的性别">
                                                        <Option value="female">女</Option>
                                                        <Option value="male">男</Option>
                                                    </Select>
                                                </div>
                                                <div class="logincom" v-if="registerType=='2'">
                                                    <Select v-model="form.enterpriseNum" placeholder="请选择企业人数">
                                                        <Option value="1~50人">1~50人</Option>
                                                        <Option value="51~100人">51~100人</Option>
                                                        <Option value="101~150人">101~150人</Option>
                                                        <Option value="151~200人">151~200人</Option>
                                                        <Option value="201~500人">201~500人</Option>
                                                        <Option value=">500人以上">500人以上</Option>
                                                    </Select>
                                                </div>
                                            </FormItem>
                                            <FormItem v-if="ifLoginRoRegister=='N'" class="loginInput" prop="mobilePhone">
                                                <div class="logincom">
                                                    <Input type="text" maxlength="11" v-model="form.mobilePhone" placeholder="请输入手机号" autocomplete="off"
                                                            @on-blur="checkRegister('mobilePhone')"@on-change="ver_disabled = 'none' " />
                                                </div>
                                            </FormItem>
                                          <FormItem prop="imgCode">
                                            <Row
                                                type="flex"
                                                justify="space-between"
                                                style="align-items: center;overflow: hidden;"
                                            >
                                              <Input
                                                  v-model="form.imgCode"
                                                  clearable
                                                  placeholder="请输入图片验证码"
                                                  :maxlength="10"
                                                  class="input-verify"
                                                  style="width: 298px"
                                              />
                                              <div style="position:relative">
                                                <Spin v-if="loadingCaptcha" fix></Spin>
                                                <img
                                                    :src="captchaImg"
                                                    @click="getCaptchaImg"
                                                    alt="加载验证码失败"
                                                    style="width:100px;cursor:pointer;display:block;height:48px;"
                                                />
                                              </div>
                                            </Row>
                                          </FormItem>
                                            <FormItem v-if="ifLoginRoRegister=='N'" class="loginInput" prop="verifyCode">
                                                <div class="logincom">
                                                    <Input   placeholder="请输入验证码" type="text" v-model="form.verifyCode" autocomplete="off"/>
                                                    <div @click="_postLoginSendSmsCode('1')" class="loginVertial"
                                                         :style="{pointerEvents:ver_disabled}">{{verifyCode_time}}
                                                    </div>
                                                </div>
                                              <p style="line-height: 18px; font-size: 12px;">如遇验证码问题请联系客服</p>
                                            </FormItem>
                                            <FormItem v-if="ifLoginRoRegister=='N'" class="loginInput" prop="password"
                                                      :style="{ marginBottom: marginBottom + 'px' }">
                                                <div class="logincom">
                                                    <Input placeholder="请输入密码" type="password" v-model="form.password" autocomplete="off"/>
                                                </div>
                                            </FormItem>
                                            <FormItem v-if="ifLoginRoRegister=='N'" class="loginInput" prop="nextPassword" :style="{ marginBottom: marginBottom + 'px' }">
                                                <div class="logincom">
                                                    <Input placeholder="请确认密码" type="password" v-model="form.nextPassword" autocomplete="off"/>
                                                </div>
                                            </FormItem>
                                            <FormItem v-if="ifLoginRoRegister=='N'">
                                                <div style="display:flex;justify-content:space-between">
                                                    <div class="fuxy">
                                                        <img @click="checkchdata()" :src="checkboxmn=='Y'?ye:noye"/>
                                                        <p>阅读并同意</p>
                                                        <a @click="lawLink(3)">《时尚知识产权保护平台用户注册协议》</a>
                                                    </div>
                                                </div>
                                            </FormItem>
                                        </Form>
                                    </TabPane>
                                </Tabs>
                                <Row>
                                    <Button :style="{marginTop:ifLoginRoRegister=='Y'?'4px':'4px'}"  class="login-btn" type="primary"
                                            size="large"  :loading="loading" @click="submitLogin" long>
                                        <span v-if="!loading">{{ ifLoginRoRegister=='Y'?$t('login'):'注册' }}</span>
                                        <span v-else>{{ $t('logining') }}</span>
                                    </Button>
                                    <div style="margin-top:20px;">
                                        <p v-if="ifLoginRoRegister=='Y'" @click="goRegister()"
                                           style="cursor:pointer;" class="goRegister">注册账号</p>
                                        <p v-if="ifLoginRoRegister=='N'" @click="goLogin()"
                                           style="width:28px;cursor:pointer;" class="goRegister">登录</p>
                                    </div>
                                </Row>

                                <Row type="flex" justify="space-between" class="other-login">
                                    <!-- <div class="lo_three">
                                        <div class="lo_weixin" @click="otherLogin(0)"></div>
                                        <div class="lo_qq" @click="otherLogin(1)"></div>
                                        <div class="lo_weibo" @click="otherLogin(2)"></div>
                                    </div>
                                    <p>未注册的手机号或第三方账号验证后将自动创建新账号</p> -->
                                </Row>
                            </Row>
                        </Col>
                        <!-- <LangSwitch /> -->
                    </Row>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {login, userInfo, initCaptcha, drawCodeImage} from "@/api/index";
    import {postLoginSendSmsCode, postThroughDynamicCode, getCheckRegister} from "@/api/staticPage";
    import {regist} from "@/api/index";
    import {validateMobile, validatePassword} from "@/libs/validate";
    import Cookies from "js-cookie";
    import Header from "@/views/main-components/header";
    import Footer from "@/views/main-components/footer";
    import LangSwitch from "@/views/main-components/lang-switch";
    import CountDownButton from "@/views/my-components/xboot/count-down-button";
    import util from "@/libs/util.js";
    import {_getProvinceAndCityList} from "@/api/authentication.js";
    import {bqjUrl} from "@/config/config"

    export default {
        name: 'login',
        components: {
            CountDownButton,
            LangSwitch,
            Header,
            Footer
        },
        data() {
            const validatePass = (rule, value, callback) => {
                if (!(/^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{8,20}$/.test(value) && value != '')) {
                    this.marginBottom = 31;
                    callback(new Error('请输入正确的密码，必须包含英文字母和数字，8到20位，不允许包含符号'));
                } else {
                    if (this.form.nextPassword !== '') {
                        // 对第二个密码框单独验证
                        this.$refs.mobileLoginForm.validateField('nextPassword');

                    }
                    callback();
                }
            };
            const validatePassCheck = (rule, value, callback) => {
                if (!(/^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{8,20}$/.test(value) && value != '')) {
                    this.marginBottom = 31;
                    callback(new Error('请输入正确的密码，必须包含英文字母和数字，8到20位，不允许包含符号'));
                } else if (value !== this.form.password) {
                    this.marginBottom = 20;
                    callback(new Error('两次输入密码不一致!'));
                } else {
                    this.marginBottom = 20;
                    callback();
                }
            };
            return {
                marginBottom: 20,
                orBtn: 0,
                captchaId: "",
                captchaImg: "",
                loadingCaptcha: true,
                error: false,
                tabName: "username",
                saveLogin: false,
                registerType:"1",
                getSms: "获取验证码",
                ifLoginRoRegister: 'Y',
                loading: false,
                sending: false,
                errorCode: "",
                verifyCode_time: '获取验证码',
                ver_disabled: 'auto',
                ifRegister: '',
                form: {
                    username: "",
                    passwordOld: "",
                    mobilePhone	:"",//	手机号
                    password	:"",//	第一次輸入密码
                    nextPassword	:"",//	第二次輸入密码
                    verifyCode	:"",//	验证码
                    inviteCode	:"",//	邀请码
                    appKey	:" ",//	应用key
                    name	:"",//	姓名
                    occupation	:"",//	职业
                    gender	:"",//	性别
                    workAddress	:"",//	工作所在地
                    enterpriseName	:"",//	企业名称
                    category	:"",//	企业类别
                    enterpriseNum	:"",//	企业人数
                    enterpriseAddress	:"",//	企业所在地
                    imgCode: "",

                },
                /**
                 * 出现了一个bug:form里面的category 绑定值，如果选择其他的时候，把categoryOhter 赋值给this.form.category，
                 * if(this.form.category == '其他')
                 * {
                 *     this.form.category = this.categoryOhter ;
                 * }
                 * 在前端能打印出数据，但是浏览器的network 截取到的categroy 是undefined，但是同样的地方，给workAddress 赋值却是可以的。
                 * */
                formCategory:"",
                categoryOther:"", //企业类别选择其他的时候，文本框绑定的内容，如果选择其他，则在最后注册时，需要将此字段赋值给category
                checkboxmn: 'N',
                ye: require('../assets/images/new_lo_ye.png'),
                noye: require('../assets/images/new_lo_hu.png'),
                loginURL: require('../assets/images/new_lo_background.png'),
                registerURL: require('../assets/images/new_lo_regbackground.png'),
                rules: {
                    username: [
                        {
                            required: true,
                            message: "账号不能为空",
                            trigger: "blur"
                        }
                    ],
                    verifyCode: [
                        {
                            required: true,
                            message: "验证码不能为空",
                            trigger: "blur"
                        }
                    ],
                    passwordOld: [
                        {
                            required: true,
                            message: "密码不能为空",
                            trigger: "blur"
                        }
                    ],
                    password: [
                        {
                            required: true,
                            message: "密码不能为空",
                            trigger: "blur"
                        },
                        {
                            validator: validatePass,
                            trigger: "blur"
                        }
                    ],
                    nextPassword: [
                        {
                            required: true,
                            message: "确认密码不能为空",
                            trigger: "blur"
                        },
                        {
                            validator: validatePassCheck,
                            trigger: "blur"
                        }
                    ],
                    imgCode: [
                        {
                            required: true,
                            message: "验证码不能为空",
                            trigger: "blur"
                        }
                    ],
                    mobile: [
                        {
                            required: true,
                            message: "手机号不能为空",
                            trigger: "blur"
                        },
                        {
                            validator: validateMobile,
                            trigger: "blur"
                        }
                    ],
                    mobilePhone: [
                        {
                            required: true,
                            message: "手机号不能为空",
                            trigger: "blur"
                        },
                        {
                            validator: validateMobile,
                            trigger: "blur"
                        }
                    ]
                },
                countrySelection: '中国', //选中国家
                provincesSelection: '北京', //选中省份
                citySelection: '北京', //选中城市
                cityData: [], //省份城市列表
            };
        },
        created() {
            this.getProvinceAndCityList()

        },
        methods: {
            /****************获取省市列表接口数据**************/
            getProvinceAndCityList() {
                _getProvinceAndCityList().then(res => {
                    if (res) {
                        console.log("省市数据：：",res);
                        this.cityData = res;
                    }
                });

            },
            provinceChange(value) {
                this.citySelection = this.cityData[value][0];
            },
            //ucenter通信
            callChild(jscode) {

                // 传参并指定回调执行函数为onBack
                for (let j = 0, len = jscode.length; j < len; j++) {
                    let script = document.createElement('script');
                    script.type = 'text/javascript';
                    script.src = jscode[j] + '&callback=onBack';
                    document.head.appendChild(script);
                }
                // let ifr = document.getElementById('main_login');
                // ifr.style.display = 'none';
                // setTimeout(function(){ top.location.reload(); }, 1000);
            },

          lawLink(id){
            let routeData = this.$router.resolve({ name: 'instrument', params: { id: id } });
            window.open(routeData.href, '_blank');
          },
            checkRegister(strphoto) {
                var myreg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/;
                if (strphoto == 'userName') {
                    if (!myreg.test(this.form.username)) {
                        toast('手机号格式不正确')
                        return false;
                    } else {
                        console.log('手机号格式正确')
                    }
                } else if (strphoto == 'phoneEmail') {
                    var emailReg = /^[A-Za-z0-9]+([_\.][A-Za-z0-9]+)*@([A-Za-z0-9\-]+\.)+[A-Za-z]{2,6}$/;
                    if (!myreg.test(this.form.username) && !emailReg.test(this.form.username)) {
                        toast('用户名格式错误');
                        return false;
                    } else {
                        console.log('用户名格式正确')
                    }
                } else {
                    if (!myreg.test(this.form.mobilePhone)) {
                        toast('手机号格式不正确')
                        return false;
                    } else {
                        console.log('手机号格式正确')
                    }
                }
                getCheckRegister({username: strphoto == 'userName' || strphoto == 'phoneEmail' ? this.form.username : this.form.mobilePhone}).then((res) => {
                    console.log(res)
                    if (res.code == 202) {
                        this.ifRegister == 'N'
                        if (strphoto == 'userName' || strphoto == 'phoneEmail') {
                            toast('该账号未注册')
                            this.ver_disabled = 'none'
                            this.orBtn = 1
                        } else if (this.ifLoginRoRegister == 'Y' && strphoto == 'mobile') {
                            toast('该账号未注册')
                            this.ver_disabled = 'none'
                        } else {
                            this.ver_disabled = 'auto'
                        }
                    } else {
                        this.ifRegister == 'Y'
                        this.orBtn = 0
                        if (strphoto == 'userName' || strphoto == 'phoneEmail') {
                            this.ver_disabled = 'auto'
                        } else {
                            toast('该账户已注册！')
                            this.ver_disabled = 'none'
                        }
                    }
                })
            },
            _postLoginSendSmsCode(type) {
                console.log('进入' + type);
                var myreg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/;
                let params;
                let _this = this
                if (type == 1) {
                    if (this.form.mobilePhone == '') {
                        toast('手机号为空')
                        return false;
                    } else if (!myreg.test(this.form.mobilePhone)) {
                        toast('手机号格式不正确')
                        return false;
                    }  else if(this.form.imgCode ==""){
                      toast('图形验证码为空')
                      return false;
                    }else {
                        console.log('手机号格式正确')
                        params = {
                            mobile: this.form.mobilePhone,
                            imageCode:this.form.imgCode,
                            captchaId:this.captchaId,
                            type: type,
                        }
                    }
                } else if (type == 4) {
                    if (!myreg.test(this.form.username)) {
                        toast('手机号格式不正确')
                        return false;
                    }  else if(this.form.imgCode ==""){
                      toast('图形验证码为空')
                      return false;
                    }else {
                        console.log('手机号格式正确')
                        params = {
                            mobile: this.form.username,
                            imageCode:this.form.imgCode,
                            captchaId:this.captchaId,
                            type: type
                        }
                    }
                } else {
                  toast('')
                  return false;
                }

                postLoginSendSmsCode(params).then(res => {
                    console.log('发送验证码成功', res)
                    if (res.code == 200) {
                        this.verifyCode_time = 60
                        this.ver_disabled = 'none'
                        const timer = setInterval(() => {
                            if (this.verifyCode_time > 0 && this.verifyCode_time <= 60) {
                                this.verifyCode_time = this.verifyCode_time - 1
                            } else {
                                clearInterval(timer);
                                this.verifyCode_time = '获取验证码'
                                this.ver_disabled = 'auto'
                            }
                        }, 1000)
                    }else{
                      toast(res.message)
                    }

                })
            },
            closeLoginDialog() {
                this.$emit('fatherClose');
            },
            checkchdata() {
                this.checkboxmn = this.checkboxmn == 'Y' ? 'N' : 'Y'
            },
            changeTabs(name) {
                console.log('获取的切换tabs的值', name)
                this.form.username = "";
                this.form.password = "";
                this.form.passwordOld = "";
                // this.form.mobile = "";
                this.form.verifyCode = '';
                this.form.inviteCode = "";
                this.form.nextPassword = "";
                this.form.mobilePhone = "";
                this.verifyCode_time = '获取验证码';
                if (name == 'username') {
                    this.ifLoginRoRegister = 'Y'
                }
                this.checkboxmn = 'N'
            },
            goRegister() {
                this.form.username = "";
                this.form.password = "";
                this.form.passwordOld = "";
                // this.form.mobile = "";
                this.form.verifyCode = '';
                this.form.inviteCode = "";
                this.form.nextPassword = "";
                this.form.mobilePhone = "";
                this.ifLoginRoRegister = 'N'
                this.tabName = 'mobile';
            },
            goLogin() {
                this.form.username = "";
                this.form.password = "";
                this.form.passwordOld = "";
                // this.form.mobile = "";
                this.form.verifyCode = '';
                this.form.inviteCode = "";
                this.form.nextPassword = "";
                this.form.mobilePhone = "";
                this.ifLoginRoRegister = 'Y'
            },
            getCaptchaImg() {
                this.loadingCaptcha = true;
                initCaptcha().then(res => {
                    this.loadingCaptcha = false;
                    if (res.success) {
                        this.captchaId = res.result;
                        this.captchaImg = bqjUrl + drawCodeImage + this.captchaId;
                    }
                });
            },
            sendSmsCode() {
                this.$refs.mobileLoginForm.validate(valid => {
                    if (valid) {
                        this.$Modal.info({
                            title: "抱歉，请获取完整版",
                            content: "支付链接: http://xpay.exrick.cn/pay?xboot"
                        });
                    }
                });
            },
            submitLogin() {
                if (this.tabName == "username") {
                    this.codeLogin();
                } else if (this.tabName == "mobile") {
                    if(this.ifLoginRoRegister == "Y"){
                        this.passWordLogin();
                    }else{
                        this.registLogin() ;
                    }
                }
            },

            //用户通过验证码登录
            codeLogin(){
                this.$refs.usernameLoginForm.validate(valid => {
                    if (valid) {
                        var myregsd = /^[1][3,4,5,6,7,8,9][0-9]{9}$/;
                        if (!myregsd.test(this.form.username)) {
                            toast('手机号格式不正确')
                            return false;
                        } else {
                            console.log('手机号格式正确')
                        }
                        if (this.ifLoginRoRegister == "N" && this.checkboxmn == 'N') {
                            toast('请勾选并同意注册协议及隐私协议')
                            return false;
                        }
                        this.loading = true;
                        postThroughDynamicCode({
                            username: this.form.username,
                            verifyCode: this.form.verifyCode,
                        }).then(res => {
                            if (res.success) {
                                this.setStore("accessToken", res.result);
                                let jscode = res.javascript;
                                this.callChild(jscode);


                                // 获取用户信息
                                userInfo().then(res => {
                                    console.log("?????????????????????", res)
                                    if (res.code == 200) {
                                        // 避免超过大小限制
                                        if (this.saveLogin) {
                                            // 保存7天
                                            Cookies.set("userInfo", JSON.stringify(res.result), {
                                                expires: 7
                                            });
                                        } else {
                                            Cookies.set("userInfo", JSON.stringify(res.result));
                                        }
                                        this.setStore("userInfo", res.result);
                                        let photo = res.result.photo ? res.result.photo : ''
                                        this.$emit('childFn', photo);
                                        this.$store.commit("setAvatarPath", photo);
                                        // 加载菜单
                                        util.initRouter(this);
                                        this.$router.push({
                                            name: "home_index"
                                        });
                                        this.closeLoginDialog()
                                    } else {
                                        this.loading = false;
                                    }
                                });
                            } else {
                                this.loading = false;
                                // this.getCaptchaImg();
                                toast(res.message)
                            }
                        });
                    }
                });
            },
            //账号密码登录
            passWordLogin(){
                this.$refs.mobileLoginForm.validate(valid => {
                    if (valid) {
                        if (this.orBtn == 1) {
                            toast("该账号未注册")
                            return false;
                        } else {
                            login({
                                username: this.form.username,
                                password: this.form.passwordOld,
                            }).then(res => {
                                if (res.success) {
                                    this.setStore("accessToken", res.result);
                                    let jscode = res.javascript;
                                    this.callChild(jscode);

                                    // 获取用户信息
                                    userInfo().then(res => {
                                        console.log("?????????????????????", res)
                                        if (res.code == 200) {
                                            // 避免超过大小限制
                                            if (this.saveLogin) {
                                                // 保存7天
                                                Cookies.set("userInfo", JSON.stringify(res.result), {
                                                    expires: 7
                                                });
                                            } else {
                                                Cookies.set("userInfo", JSON.stringify(res.result));
                                            }
                                            this.setStore("userInfo", res.result);
                                            let photo = res.result.photo ? res.result.photo : ''
                                            this.$store.commit("setAvatarPath", photo);
                                            this.$emit('childFn', photo);
                                            // 加载菜单
                                            util.initRouter(this);
                                            this.$router.push({
                                                name: "home_index"
                                            });
                                            this.closeLoginDialog()
                                        } else {
                                            this.loading = false;
                                        }
                                    });
                                } else {
                                    this.loading = false;
                                    toast(res.message)
                                }
                            });
                        }
                        this.form.saveLogin = this.saveLogin;
                    }
                });
            },
            //注册 登录
            registLogin(){

                //企业类别 是自己填写的
                if(this.formCategory =="其他"){
                    this.form.category = this.categoryOther ;
                }else{
                    this.form.category = this.formCategory ;
                }

                this.$refs.mobileLoginForm.validate(valid => {
                    if (valid) {
                        if (this.checkboxmn == 'N') {
                            toast('请勾选并同意注册协议及隐私协议')
                            return false;
                        }

                        if(this.registerType=="1")
                        {
                            this.form.workAddress = this.countrySelection + "," + this.provincesSelection + "," + this.citySelection;
                        }else{
                            this.form.enterpriseAddress =this.countrySelection + "," + this.provincesSelection + "," + this.citySelection;
                        }
                        if(this.registerType =="2"){
                            this.form.gender="unknown";
                        }

                        // this.form.category = "XXXXXXXXXXX";
                        console.log("注册传参：：",this.form);
                        regist(this.form).then(res => {
                            if (res.code == 200) {
                                toast('注册成功')
                                this.setStore("accessToken", res.result);
                                let jscode = res.javascript;
                                this.callChild(jscode);

                                // 获取用户信息
                                this.ifLoginRoRegister = 'Y'
                                userInfo().then(res => {
                                    console.log("?????????????????????", res)
                                    if (res.code == 200) {
                                        // 避免超过大小限制
                                        if (this.saveLogin) {
                                            // 保存7天
                                            Cookies.set("userInfo", JSON.stringify(res.result), {
                                                expires: 7
                                            });
                                        } else {
                                            Cookies.set("userInfo", JSON.stringify(res.result));
                                        }
                                        this.setStore("userInfo", res.result);
                                        let photo = res.result.photo ? res.result.photo : ''
                                        this.$store.commit("setAvatarPath", photo);
                                        this.$emit('childFn', photo);
                                        // 加载菜单
                                        util.initRouter(this);
                                        this.$router.push({
                                            name: "home_index"
                                        });
                                        this.closeLoginDialog()
                                    } else {
                                        this.loading = false;
                                    }
                                });
                            } else {
                                toast(res.message)
                            }
                        })

                        this.form.saveLogin = this.saveLogin;
                    }
                });
            },

            toGithubLogin() {
                this.$Modal.info({
                    title: "抱歉，请获取完整版",
                    content: "支付链接: http://xpay.exrick.cn/pay?xboot"
                });
            },
            toQQLogin() {
                this.$Modal.info({
                    title: "抱歉，请获取完整版",
                    content: "支付链接: http://xpay.exrick.cn/pay?xboot"
                });
            },
            toWeiboLogin() {
                this.$Modal.info({
                    title: "抱歉，请获取完整版",
                    content: "支付链接: http://xpay.exrick.cn/pay?xboot"
                });
            },
            toWeixinLogin() {
                this.$Message.error("开通微信登录官方收费300/年");
            },
            relatedLogin() {
            },
            handleDropDown(v) {
                this.$Modal.info({
                    title: "抱歉，请获取完整版",
                    content: "支付链接: http://xpay.exrick.cn/pay?xboot"
                });
            },
            showAccount() {
                this.$Notice.info({
                    title: "体验账号密码",
                    desc:
                        "账号1：test 密码：123456 <br>账号2：test2 密码：123456 已开放注册！",
                    duration: 10
                });
            },
            /**********三方登录*******/
            otherLogin(index) {
                let API_ROOT_UPLOAD = this.API_ROOT_UPLOAD;
                let protocol = window.location.protocol;
                let host = window.location.host;
                switch (index) {

                    //微信
                    case 0:
                        window.location.href = `${API_ROOT_UPLOAD}bqjvip/third/weixin/auth?backurl=${protocol}//${host}/index.html`;
                        break;

                    //QQ
                    case 1:
                        window.location.href = `${API_ROOT_UPLOAD}bqjvip/third/qq/auth?backurl=${protocol}//${host}/index.html`;
                        break;

                    //微博
                    case 2:
                        window.location.href = `${API_ROOT_UPLOAD}bqjvip/third/weibo/auth?backurl=${protocol}//${host}/index.html`;
                        break;
                }
            }

        },
        mounted() {
            // this.showAccount();
            // this.relatedLogin();
            this.getCaptchaImg();
        }
    };
</script>

<style scoped lang="less">
    @import "./login.less";

    .logincom {
        select {
            border: 1px solid #d4d4d4;
            padding-left: 10px;
        }
    }

    .item_content {
        flex: 1;
    }

    .item_content .selection_box:before {
        content: '';
        width: 12px;
        height: 12px;
        background: #121210;
        display: inline-block;
        margin-right: 5px;
        vertical-align: middle;
        margin-top: -3px;
    }

    .item_content .item_date_list {
        margin-right: 30px;
    }

    .item_content .item_date_list:last-child {
        margin-right: 0;
    }

    .item_content .item_city_list {
        width: 118px;
        height: 48px;
        /*margin-right: 35px;*/
    }

    .item_content .item_city_list:last-child {
        margin-right: 0;
    }

    /deep/ .item_city_list.ivu-select-single .ivu-select-selection .ivu-select-selected-value {
        text-align: center;
        color: #333333;
    }

</style>
<style type="text/css">
    .ivu-select-single .ivu-select-selection {
        height: 46px !important;
    }

    .ivu-select-single .ivu-select-selection .ivu-select-placeholder, .ivu-select-single .ivu-select-selection .ivu-select-selected-value {
        line-height: 48px;
    }
</style>
